import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import ProfilePic from '../../assets/profile-halftone.png';
import { CONTACT_ITEMS } from '../../constants';
import { TiltPhoto } from './TiltPhoto';

const INTRO = 'I build web and mobile apps with useful AI, from thoughtful interfaces to dependable backend systems.';
const INTRO_WORDS = INTRO.split(' ');
const REVEAL_EASE = [0.22, 1, 0.36, 1];

export const HeroSection = () => {
  const reduceMotion = useReducedMotion();
  const socialLinks = CONTACT_ITEMS.filter((item) => item.label !== 'Email');
  const email = CONTACT_ITEMS.find((item) => item.label === 'Email');

  return (
    <section id="hero" className="pf-hero">
      <div className="pf-container">
        <div className="pf-hero-body">
          <motion.div
            className="pf-hero-sidebar"
            initial={reduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: reduceMotion ? 0 : 0.7, ease: REVEAL_EASE }}
          >
            <TiltPhoto src={ProfilePic} alt="Jam Ardines" />
          </motion.div>
          <div className="pf-hero-copy">
            <motion.p
              className="pf-hero-role"
              initial={reduceMotion ? false : { opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: reduceMotion ? 0 : 0.45, delay: reduceMotion ? 0 : 0.12, ease: REVEAL_EASE }}
            >Full Stack AI Developer / Cebu, Philippines</motion.p>
            <h1 className="pf-hero-heading">
              <motion.span
                className="pf-hero-name"
                initial={reduceMotion ? false : { y: '105%', opacity: 0 }}
                animate={{ y: '0%', opacity: 1 }}
                transition={{ duration: reduceMotion ? 0 : 0.7, delay: reduceMotion ? 0 : 0.24, ease: REVEAL_EASE }}
              >Jam Ardines</motion.span>
            </h1>
            <p className="pf-hero-description">
              {INTRO_WORDS.map((word, index) => (
                <React.Fragment key={`${word}-${index}`}>
                  <span className="pf-hero-word-mask">
                    <motion.span
                      className="pf-hero-word"
                      initial={reduceMotion ? false : { y: '100%', opacity: 0 }}
                      animate={{ y: '0%', opacity: 1 }}
                      transition={{ duration: reduceMotion ? 0 : 0.4, delay: reduceMotion ? 0 : 0.58 + index * 0.022, ease: REVEAL_EASE }}
                    >{word}</motion.span>
                  </span>{index < INTRO_WORDS.length - 1 ? ' ' : ''}
                </React.Fragment>
              ))}
            </p>
            <nav className="pf-hero-socials" aria-label="Find Jam online">
              {socialLinks.map((item, index) => (
                <motion.a
                  key={item.label} href={item.href} target="_blank" rel="noopener noreferrer"
                  initial={reduceMotion ? false : { opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: reduceMotion ? 0 : 0.4, delay: reduceMotion ? 0 : 1.05 + index * 0.08, ease: REVEAL_EASE }}
                >
                  {item.label.toLowerCase()} <span aria-hidden="true">↗</span>
                </motion.a>
              ))}
              <motion.a
                href={email.href} aria-label="Email Jam"
                initial={reduceMotion ? false : { opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: reduceMotion ? 0 : 0.4, delay: reduceMotion ? 0 : 1.05 + socialLinks.length * 0.08, ease: REVEAL_EASE }}
              >email <span aria-hidden="true">↗</span></motion.a>
            </nav>
          </div>
        </div>
        <div className="pf-hero-bottom">
          <a href="#projects" className="pf-scroll-arrow" aria-label="Scroll to projects">↓</a>
          <span>Portfolio / 2026</span>
        </div>
      </div>
    </section>
  );
};
